/**
 * Benches — bancos de praça no gramado em frente aos prédios (como na
 * referência). Voltados para a rua, dos dois lados da entrada.
 */
import * as THREE from 'three';
import { BENCHES } from './cityLayout.js';

export function createBenches() {
  const group = new THREE.Group();
  group.name = 'benches';

  const wood = new THREE.MeshStandardMaterial({ color: '#7a5230', roughness: 0.85 });
  const metal = new THREE.MeshStandardMaterial({ color: '#1d3a26', roughness: 0.7 });

  // geometrias compartilhadas
  const seatGeo = new THREE.BoxGeometry(3.4, 0.22, 1.1);
  const backGeo = new THREE.BoxGeometry(3.4, 1.0, 0.2);
  const legGeo = new THREE.BoxGeometry(0.3, 1.0, 1.1);

  const makeBench = () => {
    const b = new THREE.Group();
    const seat = new THREE.Mesh(seatGeo, wood);
    seat.position.y = 1.0;
    seat.castShadow = true;
    const back = new THREE.Mesh(backGeo, wood);
    back.position.set(0, 1.55, -0.45);
    back.castShadow = true;
    const legL = new THREE.Mesh(legGeo, metal);
    legL.position.set(-1.5, 0.5, 0);
    const legR = new THREE.Mesh(legGeo, metal);
    legR.position.set(1.5, 0.5, 0);
    legL.castShadow = legR.castShadow = true;
    b.add(seat, back, legL, legR);
    return b;
  };

  for (const pos of BENCHES) {
    if (pos.noDraw) continue; // ex.: clínica usa placas de chão no lugar dos bancos
    const bench = makeBench();
    bench.position.set(pos.x, 0, pos.z);
    // voltado para a rua (+Z): encosto do lado do prédio (-Z local)
    group.add(bench);
  }

  return group;
}
